import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SelectBasketOffer } from 'app/shared/models/class/basket/basketList';
import { Counter, SelectCounterSessionBasketOffer } from 'app/shared/models/class/counter/counter';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { SessionBasketTraineeQuantity } from 'app/shared/models/class/session-basket/session-basket';
import { OfferSession } from 'app/shared/models/class/session/session';
import { Trainee, TraineeFullOffer } from 'app/shared/models/class/trainee/trainee';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { CounterService } from 'app/shared/services/counter/counter.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { TraineeService } from 'app/shared/services/trainee/trainee.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { OpendialogAddEditTraineeComponent } from '../../open-dialog-add-edit-trainee/opendialog-add-edit-trainee.component';
import { OpenDialogHelpComponent } from '../../open-dialog-help/open-dialog-help.component';
import { OpendialogCustomizeMySessionComponent } from '../opendialog-customize-my-session.component';

interface DialogData {
  offer: FullOffer;
  quantity: number;
  showError: boolean;
  userKey: number;
  counterSessionBasketKey: number;
  sessionKey: number;
}

@Component({
  selector: 'app-form-trainees',
  templateUrl: './form-trainees.component.html',
  styleUrls: ['./form-trainees.component.scss']
})
export class FormTraineesComponent implements OnInit {
  @Input() data: DialogData;
  @Output() traineeActiveUpdate = new EventEmitter<Trainee[]>();

  traineeActive: Trainee[] = [];
  traineeSelection: Trainee[] = [];
  trainees: TraineeFullOffer[];
  sessionSelected: OfferSession;
  limitTrainees: number;
  userKey: number;
  limitQuantity: number;
  userConnected: any;

  canCloseDialog = true;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<OpendialogCustomizeMySessionComponent>,
    private uiService: UiService,
    private traineeService: TraineeService,
    private sessionBasketService: SessionBasketService,
    private authService: AuthService,
    private counterService: CounterService,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.sessionsFiltered();

    this.getTrainees();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  drop(event: CdkDragDrop<string[]>, column?: string): void {

    // if (column === 'stagiaire_active' && this.traineeActive?.length >= this.limitQuantity) {
    //   this.uiService.showSnackbar('Il ne peut y avoir plus de stagiaires pour cette session.');
    //   return;
    // }

    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }

    this.updateSessionBasketTrainees();
  }


  openDialogAddOrEditTrainee(action: string, trainee?: Trainee) {
    const dialogRef = this.dialog.open(OpendialogAddEditTraineeComponent, {
      data: { action, trainee, userKey: this.userKey, sessionKey: this.data.sessionKey },
      minWidth: '50%',
      height: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          const { counterSessionBasketKey, offer: { sessionBasketKey }, userKey } = this.data;
          const checkSession = new SelectBasketOffer(this.userKey, sessionBasketKey);
          this.sessionBasketService.checkSessionBasketComplete(checkSession).subscribe(() => {
            this.getTraineesAfterUpdate();
          });
        }

      }
    });
  }

  private sessionsFiltered(): void {
    const { offer: { sessions, quantity } } = this.data;
    const check: OfferSession[] = sessions?.filter(session => (session.quantity - session.bookedSessionTrainees) >= quantity);
  }

  private updateSessionBasketTrainees() {
    const trainees = this.traineeActive.map(trainee => trainee.traineeKey).join(';') || '';

    const { counterSessionBasketKey, offer: { sessionBasketKey }, userKey } = this.data;

    if (!counterSessionBasketKey || counterSessionBasketKey === undefined) {

      this.sessionBasketService.UpdateSessionBasketTrainees(sessionBasketKey, trainees).subscribe({
        next: () => {
          const checkSession = new SelectBasketOffer(this.userKey, sessionBasketKey);
          const updateSession = new SessionBasketTraineeQuantity(sessionBasketKey, this.userKey, this.traineeActive.length);
          this.sessionBasketService.UpdateQuantityBasketOffer(updateSession).subscribe(() => {
            this.sessionBasketService.checkSessionBasketComplete(checkSession).subscribe(() => {
              this.getTraineesAfterUpdate();
            });
          });

          this.traineeActiveUpdate.emit(this.traineeActive);
        }
      });
    } else {

      this.counterService.updateSessionBasketTrainees(counterSessionBasketKey, trainees).subscribe({
        next: () => {
          const checkSession = new SelectCounterSessionBasketOffer(counterSessionBasketKey, this.userConnected.sub, userKey, true);
          const updateSession = new Counter(counterSessionBasketKey, this.userConnected.sub, userKey, this.traineeActive.length);
          this.counterService.updateCounterTraineeQuantity(updateSession).subscribe(() => {
            this.counterService.checkCounterSessionBasketComplete(checkSession).subscribe(() => {
              this.getTraineesAfterUpdate();

            });
          });

          this.traineeActiveUpdate.emit(this.traineeActive);
        }
      });
    }

  }

  private checkDuplicate(array: Trainee[]): Trainee[] {
    const arrayCheck = [];

    for (const item of array) {
      const index = arrayCheck.findIndex(it => it.traineeKey === item.traineeKey);
      if (index === -1) { arrayCheck.push(item); }
    }

    return arrayCheck;
  }

  private getTrainees(): void {
    this.traineeService.getTraineesBySession(this.userKey, this.data.sessionKey).subscribe({
      next: trainees => {
        this.initGetTrainee(trainees);
        this.checkIfErrorParams();
      }
    });
  }

  getTraineesAfterUpdate() {
    this.traineeService.getTraineesBySession(this.userKey, this.data.sessionKey).subscribe({
      next: trainees => {
        trainees.map((oneTrainee) => {
          let hasBeenFound = false;
          this.traineeActive.map((traineeActive, index) => {
            if (oneTrainee.traineeKey === traineeActive.traineeKey) {
              this.traineeActive[index] = oneTrainee;
              hasBeenFound = true;
            }
          })

          this.traineeSelection.map((traineeSelection, index) => {
            if (oneTrainee.traineeKey === traineeSelection.traineeKey) {
              this.traineeSelection[index] = oneTrainee;
              hasBeenFound = true;
            }
          })

          if (!hasBeenFound) {
            this.traineeSelection.push(oneTrainee)
          }
        })
        this.checkIfErrorParams();
      }
    });
  }

  private initGetTrainee(trainees: Trainee[]): void {
    trainees.forEach(trainee => {
      const traineesSelected = this.trainees.findIndex(el => el.traineeKey === trainee.traineeKey);
      traineesSelected === -1 ? this.traineeSelection.push(trainee) : this.traineeActive.push(trainee);
    });

    this.traineeSelection = this.checkDuplicate(this.traineeSelection);
    this.traineeActive = this.checkDuplicate(this.traineeActive);
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    const { offer: { hasSession, sessions, sessionKey, trainees }, userKey } = this.data;
    this.userKey = userKey;

    if (hasSession) {
      this.sessionSelected = sessions?.find(el => el.sessionKey === sessionKey);
    }

    this.trainees = trainees || [];
    const checkSession: OfferSession[] = sessions?.filter(session => (session.quantity - session.bookedSessionTrainees) >= trainees?.length);
    const checkCopy = checkSession?.length ? [...checkSession] : [];
    this.limitQuantity = Math.max(...checkCopy.map(s => s.quantity - s.bookedSessionTrainees));
  }

  checkIfErrorParams() {
    this.canCloseDialog = true;
    this.traineeActive.map(trainee => {
      trainee.hasParamsToSet = false;
      if (trainee?.parameters?.length > 0) {
        let params = trainee.parameters;
        params.map(oneParam => {
          if (!oneParam.selectedValue) {
            trainee.hasParamsToSet = true;;
            this.canCloseDialog = false;
          }
        })
      } else {
        trainee.hasParamsToSet = false;
      }
    })
  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 2 },
      width: '60%',
      maxHeight: '90%'
    });
  }
}
